import React from "react";
import JasMinerProduct1Image from "../../../../assets/JasMiner/JasminerX4-3U-1.png";

import "./Box1JasMiner.css"; // Assuming you import your CSS file for component styles

const Box1JasMiner = () => {
  return (
    <div className="mine-thunder-jas-miner-jm-container">
      <div className="mine-thunder-jas-miner-jm-right">
        <img
          src={JasMinerProduct1Image}
          alt="jas-miner Product 1"
          className="mine-thunder-jas-miner-jm-image"
        />
      </div>
      <div className="mine-thunder-jas-miner-jm-left">
        <div className="mine-thunder-jas-miner-jm-title">Jas Miner</div>
        <div className="mine-thunder-jas-miner-jm-big-title">
          Jas Miner X4-Q-3U
        </div>
        <div className="mine-thunder-jas-miner-jm-text">
          The Jas Miner X4-Q-3U stands as a game-changer in the mining
          landscape, consistently delivering remarkable results in resource
          extraction. With its state-of-the-art capabilities, this powerhouse
          miner has demonstrated an unprecedented mining output, significantly
          exceeding conventional models. Equipped with cutting-edge technology
          and an adaptive design, the X4-Q-3U optimizes the extraction process,
          showcasing its prowess in efficiently harvesting valuable resources
          from various geological formations.
          <br></br>
          <br></br>
          The efficiency of the Jas Miner X4-Q-3U is further emphasized by its
          ability to tackle large-scale mining projects with unparalleled speed
          and precision. Its advanced AI algorithms and modular structure enable
          it to adapt seamlessly to diverse mining environments, maximizing
          productivity without compromising on safety. Miners and industry
          leaders alike have celebrated the X4-Q-3U for its exceptional
          performance, making it a cornerstone in the evolution of mining
          technology and a reliable choice for those seeking unprecedented
          mining yields.
        </div>
        <a href="/jm-shop" className="mine-thunder-jas-miner-jm-shop-now">
          Shop Now
        </a>
      </div>
    </div>
  );
};

export default Box1JasMiner;
